import styled from '@xstyled/styled-components'

export const FormWrapper = styled.form`
  padding: 3;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.5);
  width: 100%;
  max-width: 400px;
  margin: 2rem auto;
  z-index: 20;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & + & {
    margin-top: 3;
  }
`

export const InputElement = styled.input`
  width: 100%;
  border: 1px solid #e0b855;
  padding: 2 1;
  margin: 2 0 0;
`

export const Label = styled.label`
  font-size: 5;
  margin-bottom: 2;
`

export const ErrorMessage = styled.span`
  font-size: 6;
  color: red;
`
